import React from 'react';
import { Button, Jumbotron, Container} from 'react-bootstrap';
import {BiCabinet} from 'react-icons/bi';
import PropTypes from 'prop-types';
export const DisplayResult = ({state, onRestart})=>{
	return(
		<>
			{state.result
				?
					<Jumbotron fluid>
						<Container>
							<h1 className="display-5 text-center" >Upload Successful</h1>
							<br/>
								<Button variant='dark' block className="text-center" onClick={onRestart}>Next Locker</Button>
							<br/>
							<p className="lead text-center">Unclear record of <BiCabinet/> {state.result} is created.</p>
							
						</Container>
					</Jumbotron>
				:
					<h5 className="text-center text-danger">Upload Failed</h5>
			}
		</>
	)
}
DisplayResult.propTypes = {
	state: PropTypes.object,
	onRestart: PropTypes.func,
};
